import { Badge } from "@/components/ui/badge"

export default function StudyGoToSituationStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Acceso a Mi Situación</h1>
      </header>
      <p className="text-left text-sm text-muted-foreground">
        ¡Seguí tu progreso de cerca! Desde este botón podés ver tus avances y todas las métricas de
        cada materia.
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 8 de 8</span>
      </Badge>
    </section>
  )
}
